import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { TipoRol } from './tipos-rol.model';

@Injectable({
  providedIn: 'root'
})
export class TiposRolService {
  url: string;

  constructor(private http: HttpClient) {}

  getTiposRol(): Observable<TipoRol[]> {
    return this.http.get<TipoRol[]>(`${this.url}/tiposRol/`);
  }

  // getTiposRolMock(): Observable<TipoRol[]> {
  //   // console.log("Entro en mock tipo rol");
  //   let listaTipoRol = [
  //     { id: 1, nombre: 'Titular' },
  //     { id: 2, nombre: 'Representante legal' },
  //     { id: 3, nombre: 'Apoderado' },
  //     { id: 4, nombre: 'Administrativo responsable' },
  //     { id: 5, nombre: 'Técnico Responsable' },
  //     { id: 6, nombre: 'Técnico Responsable acreditado' },
  //     { id: 7, nombre: 'Muestreador' },
  //     { id: 8, nombre: 'Analista de laboratorio' },
  //     { id: 9, nombre: 'Analista de laboratorio acreditado' },
  //     { id: 10, nombre: 'Técnico de campo' },
  //     { id: 11, nombre: 'Representante' }
  //   ];
  //   return of(listaTipoRol);
  // }
}
